import { IconArrowNarrowRight } from '@tabler/icons-react';

interface Props {
  onClick?: () => void;
  className?: string;
}

export default function IconProductInside(props: Props) {
  const { onClick, className } = props;

  return (
    <div 
      onClick={onClick}
      className={className}
    >
      <div className="flex h-full items-center justify-center">
        <div className="h-full">P</div>
        <IconArrowNarrowRight className='w-3' />
      </div>
    </div>
  );
}